export var generateExternalStyle = function generateExternalStyle() {
  return {
    showBrandIcon: true,
    desktopBottomBorder: true,
    desktopBottomBorderInverse: true
  };
};